<template>
  <li class="role-navigation-item" :class="{ 'is-active': isActive }" :data-item-id="item.id">
    <router-link v-if="item.link" class="role-navigation-item__link" :to="item.link">
      {{ item.label }}
    </router-link>

    <template v-else>
      <button
        type="button"
        class="role-navigation-item__group"
        :data-group-toggle="item.id"
        :aria-expanded="String(isOpen)"
        @click="$emit('toggle-group', item.id)"
      >
        {{ item.label }}
      </button>
      <ul v-if="isOpen" class="role-navigation-item__children">
        <RoleNavigationItem
          v-for="child in item.children"
          :key="child.id"
          :item="child"
          :active-item-id="activeItemId"
          :open-group-ids="openGroupIds"
          @toggle-group="$emit('toggle-group', $event)"
        />
      </ul>
    </template>
  </li>
</template>

<script>
function containsItem(item, itemId) {
  return item.id === itemId || item.children.some((child) => containsItem(child, itemId));
}

/** One entry (router link) or group (toggle with children) of the new navigation. */
export default {
  name: 'RoleNavigationItem',
  props: {
    item: { type: Object, required: true },
    activeItemId: { type: String, default: null },
    openGroupIds: { type: Array, required: true },
  },
  computed: {
    /** An entry is active itself; a group is active when it contains the active entry. */
    isActive() {
      return this.activeItemId !== null && containsItem(this.item, this.activeItemId);
    },
    isOpen() {
      return this.openGroupIds.includes(this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.role-navigation-item {
  list-style: none;

  &.is-active > .role-navigation-item__link,
  &.is-active > .role-navigation-item__group {
    font-weight: 600;
  }
}

.role-navigation-item__link,
.role-navigation-item__group {
  display: block;
  width: 100%;
  padding: 6px 16px;
  border: 0;
  background: transparent;
  color: var(--sidebar-color);
  text-align: left;
  text-decoration: none;

  &:hover {
    background-color: rgba($gray-600, 0.08);
    color: var(--sidebar-color);
    text-decoration: none;
  }
}

.role-navigation-item__children {
  margin: 0;
  padding: 0 0 0 16px;
}
</style>
